// src/pages/PatientsOverview/components/InsuranceCompanyList.js
import React, { useEffect } from "react";
import { Table, Button, Space, message, Modal } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  selectInsuranceList,
  selectIsInsuranceModalOpen,
} from "../PatientsSelectors";
import { fetchInsuranceList, removeInsurance } from "../PatientsThunk";
import { openInsuranceModal, closeInsuranceModal } from "../PatientsSlice";
import CompanyModal from "./CompanyModal";
import dayjs from "dayjs";

const { confirm } = Modal;

const InsuranceCompanyList = () => {
  const dispatch = useDispatch();
  const list = useSelector(selectInsuranceList);
  const isModalOpen = useSelector(selectIsInsuranceModalOpen);

  useEffect(() => {
    // ensure list loaded when component mounts
    dispatch(fetchInsuranceList());
  }, [dispatch]);

  const handleEdit = (record) => {
    // record is expected shape similar to original transform
    dispatch(openInsuranceModal(record));
  };

  const handleDelete = (record) => {
    confirm({
      title: "Are you sure delete this?",
      onOk: async () => {
        try {
          await dispatch(removeInsurance(record.insurance_company_id)).unwrap();
          message.success("Insurance deleted successfully");
          dispatch(fetchInsuranceList());
        } catch (err) {
          message.error(err?.message || "Delete failed");
        }
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "index",
      render: (_, __, idx) => idx + 1,
    },
    {
      title: "Insurance Company",
      dataIndex: "company_name",
      key: "company_name",
      render: (v) => v || "N/A",
    },
    {
      title: "Validity Date",
      dataIndex: "valid_upto",
      key: "valid_upto",
      render: (v) => (v ? dayjs(v).format("YYYY-MMM-DD") : "-"),
    },
    {
      title: "Contact Person",
      dataIndex: "contact_name",
      key: "contact_name",
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (val, rec) =>
        rec.country_code ? `+${rec.country_code} ${val}` : val,
    },
    {
      title: "Email Address",
      dataIndex: "email_id",
      key: "email_id",
    },
    {
      title: "Receiver ID",
      dataIndex: "receiver_id",
      key: "receiver_id",
    },
    {
      title: "Payer ID",
      dataIndex: "payer_id",
      key: "payer_id",
    },
    // optionally show totals if present
    {
      title: "Total Patients",
      dataIndex: "total_patients",
      key: "total_patients",
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount_paid",
      key: "total_amount_paid",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>            
          </Button>
          <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record)}>            
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 16,
        }}
      >
        <Button
          type="primary"
          onClick={() => dispatch(openInsuranceModal(null))}
          data-testid="new-company"
        >
          + New Company
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={list}
        rowKey={(r) => r.insurance_company_id || Math.random()}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />
      {isModalOpen && <CompanyModal />}
    </div>
  );
};

export default InsuranceCompanyList;
